import { useMemo } from 'react'
/**
 * returns the currently logged in user
 */
export const useUser = () => {
  // REVIEW: this is not great as it seems some of the app is using the mobx and other parts using redux
  // this method relies on the "deprecated" tokenStorage, see @lib/tokenStorage

  const userJson = window.localStorage.getItem('ngStorage-user')
  return useMemo(() => {
    return userJson && JSON.parse(userJson)
  }, [userJson])
}
